export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/sleep-tangerine.8751d74b530006d7d64194d2bb6c9716.png";